import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El Tomo I arranca desde cero y te lleva de la mano. Todo está explicado paso a paso.'
  }, {
    q: '¿Los materiales son difíciles de conseguir?',
    a: 'Todo lo que se usa se consigue en ferias, dietéticas o supermercados de Argentina. Sal, hierbas, velas — nada exótico.'
  }, {
    q: '¿Cómo recibo los archivos?',
    a: 'Por email en menos de 5 minutos después del pago. PDF listo para leer en cualquier dispositivo o imprimir.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. 7 días, devolución del 100%, sin condiciones. Menos del 1% de devoluciones.'
  }, {
    q: '¿Sirve si vivo con personas escépticas?',
    a: 'Sí. Cada tomo incluye un Modo Discreto con técnicas que podés aplicar sin que nadie lo note. Los cambios los sienten todos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-68">
      <div className="text-center mb-12" data-id="element-69">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[24px]" data-id="element-70">
          <span className="mr-3" data-id="element-71">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-72">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-gold/15" data-id="element-73">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-74">
              <span className="font-medium pr-8 text-[16px] text-brand-text" data-id="element-75">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-76" />
            </button>
            <AnimatePresence data-id="element-77">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-78">
                  <div className="px-6 pb-5 text-brand-text/80 border-t border-brand-gold/15 pt-4 text-[14px]" data-id="element-79">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};